import React from 'react';

const Divider: React.FC = () => {
  return (
    <hr className='h-px my-4 border-accent border-2 w-24' />
  );
};

export default Divider;